import { cloneDeep, set } from "lodash-es"
import React, { useState } from "react"
import CustomDialog from "components/Atoms/CustomDialog"
import StaticSelector from "components/Atoms/StaticSelector"
import ButtonMutation from "components/Molecules/ButtonMutation"
import { ApolloErrorToast, SuccessToast } from "utils/AppToaster"
import { useAllSkusList } from "graphql/dms/dms.hooks.gql"
import StringInput from "components/Atoms/StringInput"
const AddExtraSkuDialog = ({ isOpen, onClose, tripId, ...otherProps }) => {
  const allSkus = useAllSkusList()
  const [state, setState] = useState<any>({
    sku: {},
    quantity: 0,
  })

  function handleChange(path, value) {
    const stateCopy = cloneDeep(state)
    set(stateCopy, path, value)
    setState(stateCopy)
  }

  return (
    <CustomDialog
      title={
        <div>
          <text>Add extra SKU</text>
        </div>
      }
      isOpen={isOpen}
      footerRightButton={
        <ButtonMutation
          icon="confirm"
          text="Add"
          mutation={null}
          variables={{
            tripId: tripId,
            extraSkus: [
              {
                skuId: state?.sku?.id,
                quantity: state?.quantity,
              },
            ],
          }}
          onError={err => {
            ApolloErrorToast(err)
          }}
          onCompleted={() => {
            SuccessToast(`SKU added successfully`)
            onClose()
          }}
        />
      }
      width="50%"
      onClose={onClose}
      {...otherProps}
    >
      <div>
        <div className="grid grid-cols-12 gap-4 mt-3">
          <div className="col-span-6">
            <StaticSelector
              path="sku"
              label="SKU type"
              absolute
              items={allSkus || []}
              value={state.sku}
              onChange={handleChange}
            />
          </div>
          <div className="col-span-6">
            <StringInput
              label="Quantity"
              path="quantity"
              type="number"
              value={state?.quantity}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </CustomDialog>
  )
}

export default AddExtraSkuDialog
